import React from "react";

export default class Socials extends React.Component {

    constructor(props)
    {
        super(props);
        this.env = this.props.env;

        this.face = this.env.site === 'dumpster' ? "https://www.facebook.com/HometownDumpsterRental/" : "https://www.facebook.com/HometownDemolitionContractors/";
        this.twit = this.env.site === 'dumpster' ? "https://twitter.com/hometowndumpstr" : "https://twitter.com/HometownDemo";
        this.pin = 'https://www.pinterest.com/hometowndiytips/'
        this.tube = this.env.site === 'dumpster' ? 'https://www.youtube.com/c/HometownDumpsterRental' : 'https://www.youtube.com/channel/UCVlHIvd1yvOU1fT7d7YdZXg/videos'
    }

    render() 
    {   
        const requestImageFile = require.context('../images/', true, /.png$/);
        const logo = './logo-'+this.env.site+'.png';
        
        if(this.props.show)
        {
            return (        
                <ul className="socials">
                    <li>
                        <img className="logo-footer-img" src={requestImageFile(logo)?.default} alt="Hometown logo"></img>
                    </li>
                    <li className="front-li social">
                        <a className="front-link" role="button" aria-label="facebbok" rel="noreferrer" href={this.face} target="_blank"><i className="fab fa-facebook-square" ></i></a>
                        <a className="front-link" role="button" aria-label="twitter" rel="noreferrer" href={this.twit} target="_blank"><i className="fab fa-twitter-square" ></i></a>
                        <a className="front-link" role="button" aria-label="pinterest" rel="noreferrer" href={this.pin} target="_blank"><i className="fab fa-pinterest-square" ></i></a>          
                        <a className="front-link" role="button" aria-label="youtube" rel="noreferrer" href={this.tube} target="_blank"><i className="fab fa-youtube-square" ></i></a>
                    </li>
                </ul>
            );
        }

        return (<></>);
    }
}